
//------------------------------------------------------------------
//------------------------------------------------------------------
export const regUserCookieName = "reguser";
export const annUserCookieName = "annuser";

//------------------------------------------------------------------
export const generateUniqueID = () => {
    // e.g. U1576996323453
    return "U"+Date.now();
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const setCookie = (name,value,days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ)===0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const eraseCookie = (name) => {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

//------------------------------------------------------------------
//------------------------------------------------------------------
export const setAnnUserCookie = (name,id) => {
    var val = name+"|"+id+"|b";
    setCookie(annUserCookieName,val,100);
}
export const getAnnUserInfo = () => {
    var val = getCookie(annUserCookieName);
    if (val === null) return null;
    var usr = val.split("|");
    //var isa = usr.length>=3 && usr[2]==='a'
    //setLoggedinUser({id:usr[1], name:usr[0], admin:isa});
    return usr;
}
export const getRegUserInfo = () => {
    var val = getCookie(regUserCookieName);
    if (val === null) return null;
    var usr = val.split("|");
    //var isa = usr.length>=3 && usr[2]==='a'
    //setLoggedinUser({id:usr[1], name:usr[0], admin:isa});
    return usr;
}
const USER_NAME_IDX = 0;
const USER_ID_IDX = 1;
const USER_ISA_IDX = 2;
//const USER_MAX = 3;
export const getUserName = (userInfo) => {
    if (userInfo !== null && userInfo.length > USER_NAME_IDX) {
        return userInfo[USER_NAME_IDX];
    }
    return "";
}
export const getUserId = (userInfo) => {
    if (userInfo !== null && userInfo.length > USER_ID_IDX) {
        return userInfo[USER_ID_IDX];
    }
    return "";
}
export const getUserIsa = (userInfo) => {
    if (userInfo !== null && userInfo.length > USER_ISA_IDX) {
        return Boolean(userInfo[USER_ISA_IDX]==='a');
    }
    return false;
}
export const setRegUserCookie = (name,id,isa) => {
    var val = name+"|"+id+"|"+(isa?'a':'b');
    setCookie(regUserCookieName,val,100);
}

